import Nullstack from 'nullstack';
export default function IconAnalyze({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-analyze",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M20 11a8.1 8.1 0 0 0 -6.986 -6.918a8.095 8.095 0 0 0 -8.019 3.918"
  }), "   ", Nullstack.element("path", {
    d: "M4 13a8.1 8.1 0 0 0 15.001 2.998"
  }), "   ", Nullstack.element("circle", {
    cx: "19",
    cy: "16",
    r: "1"
  }), "   ", Nullstack.element("circle", {
    cx: "5",
    cy: "8",
    r: "1"
  }), "   ", Nullstack.element("circle", {
    cx: "12",
    cy: "12",
    r: "3"
  }), " ");
}